export const sortArray = (a, b) => {
  return a - b;
}
